import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";

const eur = (n) => (Number(n) || 0).toLocaleString("it-IT", { style: "currency", currency: "EUR" });
const key = (a) => `acc|${(a.name || "").trim().toLowerCase()}`;
export const parseQty = (q) => {
  const m = String(q ?? "").replace(",", ".").match(/\d+(\.\d+)?/);
  return m ? Number(m[0]) : null;
};

export const useAccessoryPrices = (s) => useQuery({
  queryKey: ["model-sheet-accessory-prices", s.id, s.updated_at],
  queryFn: async () => (await api.get(`/model-sheets/${s.id}/accessory-prices`)).data,
  enabled: !!s.id,
});

export const accessoryLines = (s, auto = []) => (s.tech?.accessories || []).filter((a) => a.name?.trim()).map((a) => {
  const k = key(a);
  const info = auto.find((x) => x.key === k) || {};
  const manual = s.costs?.fabric_prices?.[k];
  const price = manual !== undefined && manual !== null && manual !== "" ? Number(manual) : info.price;
  const qty = parseQty(a.quantity);
  return { a, k, info, manual, price, qty, cost: (qty || 0) * (Number(price) || 0) };
});

const Source = ({ i }) => (i.price != null
  ? <span>da materie prime{i.supplier ? ` · ${i.supplier}` : ""}{i.unit ? ` · prezzo per ${i.unit}` : ""}</span>
  : <span className="text-rose-400">prezzo non trovato: inseriscilo a mano</span>);

export const AccessoryCosts = ({ lines, onPrice }) => (
  <div className="overflow-x-auto rounded-md border border-border">
    <table className="w-full text-sm" data-testid="stylist-accessory-costs">
      <thead><tr className="border-b border-border text-xs text-muted-foreground">
        <th className="p-2 text-left font-medium">Accessorio</th><th className="p-2 text-right font-medium">Quantità</th>
        <th className="p-2 text-right font-medium">Prezzo unitario (€)</th><th className="p-2 text-right font-medium">Costo</th>
      </tr></thead>
      <tbody>
        {lines.map((l, i) => (
          <tr key={i} className="border-b border-border/50 last:border-0" data-testid={`stylist-accessory-${i}`}>
            <td className="p-2"><p>{l.a.name}</p><p className="text-[11px] text-muted-foreground"><Source i={l.info} /></p></td>
            <td className={`p-2 text-right ${l.qty ? "" : "text-rose-400"}`}>{l.qty ? l.a.quantity : "manca"}</td>
            <td className="p-2 text-right">
              <Input type="number" min="0" step="0.01" value={l.manual ?? ""} placeholder={l.info.price != null ? String(l.info.price) : "0"}
                onChange={(e) => onPrice(l.k, e.target.value)} className="ml-auto h-8 w-24 text-right" data-testid={`stylist-accessory-${i}-price`} />
            </td>
            <td className="p-2 text-right font-medium" data-testid={`stylist-accessory-${i}-cost`}>{eur(l.cost)}</td>
          </tr>
        ))}
        {!lines.length && <tr><td colSpan={4} className="p-3 text-xs text-muted-foreground">Nessun accessorio nella versione modelliste.</td></tr>}
      </tbody>
    </table>
  </div>
);
